import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, {
    siteKey: "6LfLHXkbAAAAAOy46407wUtpCABPMyqVtLNVB6tn"
});